// extracted by mini-css-extract-plugin
module.exports = {"inp-frm":"InputForm_inp-frm__ZK8O7","modal-form":"InputForm_modal-form__2-j2-","btn":"InputForm_btn__2MUXb"};